// Client-only `process` polyfill. Some vendored ESM chunks read `process.env.X`
// in the browser, which throws "process is not defined" (an unhandledrejection).
// This file is imported FIRST by main.tsx (the browser entry only) so it runs
// before any vendor module evaluates. It must NEVER be imported by server code —
// the previous attempt (a broad `'process.env': '{}'` Vite define) leaked into the
// Nitro server build and nulled SUPABASE_SERVICE_ROLE_KEY, taking /api/agent down.
if (typeof globalThis !== 'undefined') {
  const g = globalThis as unknown as { process?: { env?: Record<string, unknown> } };
  if (typeof g.process === 'undefined') {
    g.process = { env: {} };
  } else if (typeof g.process.env === 'undefined') {
    g.process.env = {};
  }
}

export {};
